module.exports = __webpack_public_path__ + "static/media/metacognition@2x.b87bfca3.png";